import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Fetch } from "../../../shared/Fetch";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { EmptyTenderServiceDepartment, IModel, ITenderServiceDepartment } from "./TenderServiceDepartmentMast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { InputSwitch } from "primereact/inputswitch";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";

interface IProps {
  permission: IPermissionProps;
  setModal: (modal: IModel) => void;
  toast: any;
  reload: boolean;
}

const Table = (props: IProps) => {
  const [tableData, setTableData] = useState<{ tableData: ITenderServiceDepartment[]; loading: boolean }>({ tableData: [], loading: false });
  const [descriptionDialog, setDescriptionDialog] = useState({ visible: false, description: "" });

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DateFormat = loginObj.date_Format;

  const loadData = async () => {
    try {
      setTableData((prev) => ({ ...prev, loading: true }));
      const response = await Fetch("Tender_Service_Department/GetAll", "GET", null, null, props.toast);
      if (response?.ok) {
        const data = await response.json();
        setTableData({ tableData: data, loading: false });
      }
    } catch {
    } finally {
      setTableData((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    loadData();
  }, [props.reload]);

  const openNew = () => {
    props.setModal({ open: true, singleData: EmptyTenderServiceDepartment });
  };

  const leftToolbarTemplate = () => {
    return <Button label="New" icon="pi pi-plus" className="p-button-success" onClick={openNew} />;
  };

  const actionBody = (rowData: ITenderServiceDepartment) => {
    return <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => props.setModal({ open: true, singleData: rowData })} />;
  };

  const changeStatus = (rowData: ITenderServiceDepartment, status: boolean) => {
    confirmDialog({
      header: "Confirmation",
      message: status ? `Are you sure you want to activate "${rowData.department_Name}"?` : `Are you sure you want to deactivate "${rowData.department_Name}"?`,
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        const response = await Fetch("Tender_Service_Department/ChangeStatus", "PUT", null, `id=${rowData.id}&status=${status}`, props.toast);

        if (response?.ok) {
          props.toast.current.show({
            severity: "success",
            summary: "Success",
            detail: status ? `"${rowData.department_Name}" activated successfully.` : `"${rowData.department_Name}" deactivated successfully.`,
            life: 3000,
          });
          loadData();
        }
      },
      reject: () => {
        loadData();
      },
    });
  };
  return (
    <>
      <ConfirmDialog />
      <Toolbar left={leftToolbarTemplate} className="mb-3" />
      <DataTable value={tableData.tableData} loading={tableData.loading} stripedRows showGridlines responsiveLayout="scroll" header="RFP Service Department List">
        <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ width: "50px" }} />
        <Column field="department_Name" header="Department Name" />
        <Column
          header="Description"
          body={(rowData: ITenderServiceDepartment) =>
            rowData.description ? (
              <>
                <Tooltip target=".view-description" />
                <i className="pi pi-eye view-description cursor-pointer" data-pr-tooltip="View Description" data-pr-position="top" style={{ color: "var(--primary-color)", fontSize: "1.2rem" }} onClick={() => setDescriptionDialog({ visible: true, description: rowData.description || "" })} />
              </>
            ) : (
              "-"
            )
          }
        />
        <Column field="addedBy" header="Description" />
        <Column header="Status" body={(rowData: ITenderServiceDepartment) => <InputSwitch checked={rowData.status} onChange={(e) => changeStatus(rowData, e.value)} />} />
        <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)} style={{ width: "140px" }} />
        <Column header="Actions" body={actionBody} style={{ width: "70px" }} />
      </DataTable>
      <Dialog header="Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
      </Dialog>
    </>
  );
};

export default Table;
